import { Loader2, X } from "lucide-react";
import { ButtonFluxi } from "../../common/Buttons/ButtonFluxi/ButtonFluxi";

interface ModalMercadoPagoIntegrationProps {
    id: string;
    setModalOpenMercadoPago: (open: boolean) => void;
    handlePostMercadoPagoIntegration: (tokenPublic: string, tokenPrivate: string, id: string) => void;
    tokenPublic: string;
    setTokenPublic: (token: string) => void;
    tokenPrivate: string;
    setTokenPrivate: (token: string) => void;
    loading: boolean;
}

const ModalMercadoPagoIntegration = ({ id, setModalOpenMercadoPago, handlePostMercadoPagoIntegration, tokenPublic, setTokenPublic, tokenPrivate, setTokenPrivate, loading }: ModalMercadoPagoIntegrationProps) => {


    return (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-center items-center">
            <div className="bg-white p-4 rounded-lg shadow-xl w-full max-w-md flex flex-col items-center justify-center relative">
                <button className="absolute top-4 right-4" onClick={() => setModalOpenMercadoPago(false)}>
                    <X />
                </button>
                <div className="flex flex-col items-center justify-center gap-4 w-[225px] h-[100px]">
                    <img src="https://http2.mlstatic.com/frontend-assets/mp-web-navigation/ui-navigation/6.7.73/mercadopago/logo__large@2x.png" alt="Mercado Pago" className="w-full h-auto" />
                </div>
                <div className="flex flex-col items-center justify-center gap-4 w-full mt-4">
                    <div className="flex flex-col items-start justify-center gap-2 w-full">
                        <p className="text-sm text-gray-500 font-bold">Token público*:</p>
                        <textarea name="" id="" className="w-full h-[100px] border border-gray-300 rounded-lg p-2" placeholder="Ingresa tu token de Mercado Pago" value={tokenPublic} onChange={(e) => setTokenPublic(e.target.value)}></textarea>
                    </div>
                    <div className="flex flex-col items-start justify-center gap-2 w-full">
                        <p className="text-sm text-gray-500 font-bold">Token privado*:</p>
                        <textarea name="" id="" className="w-full h-[100px] border border-gray-300 rounded-lg p-2" placeholder="Ingresa tu token de Mercado Pago" value={tokenPrivate} onChange={(e) => setTokenPrivate(e.target.value)}></textarea>
                    </div>
                </div>
                <div className="flex flex-col items-center justify-center gap-4 w-full mt-4">
                    <ButtonFluxi disabled={tokenPublic === "" || tokenPrivate === "" || loading} onClick={() => handlePostMercadoPagoIntegration(tokenPublic, tokenPrivate, id)}>
                        {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Conectar"}
                    </ButtonFluxi>
                </div>
            </div>
        </div>
    );
};

export default ModalMercadoPagoIntegration;